<div id="list-request" *ngIf="templateView==1">
    <h2 class="mt-5 font-weight-bolder"><i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{ "GENERAL.LISTING_REQUEST" | translate }}</h2>

    <div class="card card-custom gutter-b mt-10">
        <div class="card-body py-0 px-0">
            <div class="row mx-3">
                <div class="col-md-12 my-5">
                    <span class="font-weight-boldest font-size-h6 text-dark-50">{{ "MENU.H4FILTER" | translate}}</span>
                </div>
            </div>
            <div class="form-group row mx-3 justify-content-md-left">
                <div class="col-md-12">
                    <form
                    [formGroup]="filterRequestForm"
                    (ngSubmit)="submitFilterRequest()"
                    >
                        <div class="row mb-4">
                            <div class="col-md-4">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="sr-only">{{ "INPUT.YEAR" | translate }}</label>
                                            <select class="form-control" placeholder="" formControlName="inputAnyo" name="inpuAnyo">
                                                <option value="">{{ "INPUT.YEAR" | translate }}</option>
                                                <option *ngFor="let item of anyos | async" value="{{item.IdAno}}">{{item.Ano}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="sr-only">{{ "INPUT.MONTH" | translate }}</label>
                                            <select class="form-control" placeholder="" formControlName="inputMes" name="inputMes">
                                                <option value="">{{ "INPUT.MONTH" | translate }}</option>
                                                <option *ngFor="let item of meses | async" value="{{item.Mes}}">{{item.Descripcion}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="sr-only">{{ "INSURANCE.ENDOSOTYPE" | translate }}</label>
                                    <select class="form-control" formControlName="inputIdTipoEndoso" name="inputIdTipoEndoso">
                                        <option value="">{{ "INSURANCE.ENDOSOTYPE" | translate }}</option>
                                        <option *ngFor="let item of endosos  | async" value="{{item.IdTipoEndoso}}">{{ item.TipoEndoso }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="sr-only">{{ "INSURANCE.BY_STATUS" | translate }}</label>
                                    <select class="form-control" formControlName="inputStatus" name="inputStatus">
                                        <option value="">{{ "INSURANCE.BY_STATUS" | translate }}</option>
                                        <option *ngFor="let item of status  | async" value="{{item.IdEstatus}}">{{ item.Estatus }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                            
                        <div class="row mb-4">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="sr-only">{{ "INPUT.BY_POLICY_NUM" | translate }}</label>
                                    <input class="form-control" placeholder="{{ 'INPUT.BY_POLICY_NUM' | translate }}" formControlName="inputNroDePoliza" name="inputNroDePoliza">
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="form-group mb-0">
                                    <button [disabled]="activeSubmitFilterPolicy" type="submit" class="btn btn bg-success text-white font-weight-boldest  mr-2" >{{ "INPUT.FILTER" | translate }}</button>
                                    <button type="reset" class="btn btn-default text-dark-50 font-weight-boldest ">{{ "INPUT.RESET" | translate }}</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="card card-custom gutter-b mt-10">
        <div class="card-header d-none">
            <div class="card-title">
                <h3 class="card-label">{{ "GENERAL.LISTING_REQUEST | translate }}</h3>
            </div>
        </div>
        
        <div class="card-body py-0 px-0">
            <div class="table-responsive angular-bootstrap-table">
                <table class="table table-head-custom table-vertical-center overflow-hidden" style="border-radius: 0.42rem;">
                    <thead style="background-color: rgb(130,124,120);color:white;">
                        <th class="">{{ "INSURANCE.POLICY" | translate }}</th>
                        <th>{{ "INSURANCE.REQUEST_TYPE" | translate }}</th>
                        <th>{{ "INSURANCE.DETAILS" | translate }}</th>
                        <th>{{ "INSURANCE.STATUS" | translate }}</th>
                        <th>{{ "INSURANCE.REQUEST_DATE" | translate }}</th>
                        <th>{{ "INSURANCE.AGENT" | translate }} </th>
                        <th>{{ "INSURANCE.REQUEST_CREATED" | translate }}</th>
                        <th>{{ "INSURANCE.DAYS_PASSED" | translate }}</th>
                        <th>&nbsp;</th>
                    </thead>
                    <tbody>
               
                        <tr *ngFor="let request of requestService.items$ | async; let i = index">
                            <td>{{ request.NroDePoliza }}</td>
                            <td>{{ request.TipoEndoso }}</td>
                            <td>{{ request.Observacion }}</td>
                            <td>{{ request.Estatus }}</td>
                            <td>{{ request.FechaCreacion | date: 'MM/dd/yyyy' }}</td>
                            <td>{{ request.Agente }}</td>
                            <td>{{ request.FechaAplicacion | date: 'MM/dd/yyyy' }}</td>
                            <td>{{ request.DiasTranscurridos }} {{ "INSURANCE.DAYS" | translate }}</td>
                            <td>
                                <button type="button" class="btn " (click)="clickModalRequest(request, requestModal)" data-toggle="tooltip" title='{{ "INPUT.VIEW" | translate }}'><i class="fa fa-eye"></i></button>
                            </td>
                        </tr>
            
                    </tbody>
                </table>
            </div>
            <!--
            <app-paginator class="d-flex justify-content-between align-items-center flex-wrap" [paginator]="paginator"
                [isLoading]="isLoading" (paginate)="paginate($event)"></app-paginator>-->
        </div>
    </div>
</div>

<div class="loadingModal">
    <ng-template #loadingModal let-c="close" let-d="dismiss">
        <div class="modal-body">
            <div class="loading-totalesModal">
                <div class="spinner spinner-track spinner-primary spinner-lg mr-15"><span class="font-weight-boldest pl-10">{{ "GENERAL.LOADING" | translate }} ...</span></div>
            </div>
        </div>
    </ng-template>
</div>

<div class="requestModal">
    <span *ngIf="closeResult">
      <pre>{{closeResult}}</pre>
    </span>
    <div>
    <ng-template #requestModal let-c="close" let-d="dismiss">
        <div class="modal-header">
            <h4 class="modal-title font-weight-bolder">{{ "INSURANCE.REQUEST" | translate }}</h4>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="row mt-3">
                <div class="col-4 font-weight-boldest">{{ "INSURANCE.POLICY" | translate}}</div>
                <div class="col-8 ">{{requestDetail.NroDePoliza}}</div>
            </div>

            <div class="row mt-3"> 
                <div class="col-4 font-weight-boldest">{{ "INSURANCE.REQUEST_TYPE" | translate}}</div>
                <div class="col-8 ">{{ requestDetail.TipoEndoso }}</div>
            </div>

            <div class="row mt-3"> 
                <div class="col-4 font-weight-boldest">{{ "INSURANCE.DETAILS" | translate}}</div>
                <div class="col-8 ">{{requestDetail.Observacion}}</div>
            </div>

            <div class="row mt-3"> 
                <div class="col-4 font-weight-boldest">{{ "INSURANCE.STATUS" | translate}}</div>
                <div class="col-8 ">{{requestDetail.Estatus}}</div>
            </div>

            <div class="row mt-3"> 
                <div class="col-4 font-weight-boldest">{{ "INSURANCE.AGENT" | translate}}</div>
                <div class="col-8">{{requestDetail.Agente}}</div>
            </div>

            <div class="row mt-3"> 
                <div class="col-4 font-weight-boldest">{{ "INSURANCE.REQUEST_DATE" | translate}}</div>
                <div class="col-8">{{requestDetail.FechaCreacion | date: 'MM/dd/yyyy' }}</div>
            </div>

            <div class="row mt-3"> 
                <div class="col-4 font-weight-boldest">{{ "INSURANCE.REQUEST_CREATED" | translate}}</div>
                <div class="col-8">{{requestDetail.FechaAplicacion | date: 'MM/dd/yyyy' }}</div>
            </div>

            <div class="row mt-3"> 
                <div class="col-4 font-weight-boldest">{{ "INSURANCE.DAYS_PASSED" | translate}}</div>
                <div class="col-8 " >{{requestDetail.DiasTranscurridos}} {{ "INSURANCE.DAYS" | translate }}</div>
            </div>

        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default text-dark" (click)="c('Close click')">{{ "INPUT.CLOSE" | translate}}</button>
        </div>
    </ng-template>
</div>

<ng-template
  #formError
  let-control="control"
  let-message="message"
  let-validation="validation"
>
  <ng-container
    *ngIf="control.hasError(validation) && (control.dirty || control.touched)">
    <div class="fv-plugins-message-container">
      <div class="fv-help-block">
        {{ message }}
      </div>
    </div>
  </ng-container>
</ng-template>